
import Vue from 'vue';
import store from '@/store';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Action, Getter, Mutation } from 'vuex-class';
import { Category } from '@/types/categories';
import { Content } from '@/types/content';
import _ from 'lodash';
import ContentListTile from '../../components/Content/ContentListTile.vue';
import {debounce} from "typescript-debounce-decorator";

@Component({
  components: { ContentListTile },
})
export default class ContentList extends Vue {
  @Action('content/getPage') getPage!: Function;
  @Action('content/restoreContent') restoreContent!: Function;
  @Getter('content/content') content!: Content[];
  @Getter('content/contentLoading') contentLoading!: boolean;
  @Getter('content/showDeleted') showDeleted!: boolean;
  @Getter('content/totalPages') totalPages!: number;
  @Getter('categories/category') category!: Category;
  @Getter('categories/categories') categories!: Category[];
  @Mutation('content/toggleShowDeleted') toggleShowDeleted!: Function;
  @Mutation('editor/setCategoryId') setCategoryId!: Function;
  @Prop() categorySlug!: string;

  search: string = '';

  get pageName() {
    const name = this.$route.name || undefined;

    if (this.categorySlug === undefined) {
      return _.startCase(name);
    } else {
      return _.startCase(name) + ': ' + this.category.name;
    }
  }

  get categoryAction() {
    if (this.categorySlug !== undefined) {
      return 'for ' + this.category.name + ' Category';
    }
  }

  get currentPage() {
    return this.$store.getters['content/currentPage'];
  }

  set currentPage(page) {
    this.getPage({ page, category: this.categorySlug, terms: this.search });
  }

  get filteredContent() {
    if (this.categorySlug === undefined) {
      return this.content;
    } else {
      return this.content.filter(
        (item: Content) => item.category_id === this.category.id,
      );
    }
  }

  newContent() {
    store.dispatch('editor/resetEditor');
    this.setCategoryId(this.category.id);
    this.$router.push('/content/editor');
  }

  @Watch('search')
  @debounce(1000, { leading: false })
  onSearchChanged() {
    this.getPage({ page: 1, category: this.categorySlug, terms: this.search });
  }

  @Watch('showDeleted')
  onShowDeletedChanged() {
    this.getPage({ page: 1, category: this.categorySlug, terms: this.search });
  }

  async beforeRouteEnter(to: Route, from: Route, next: Function) {
    const category: string | null =
      to.params.category !== undefined ? to.params.category : null;

    const loadCategory = category
      ? store.dispatch('categories/getCategory', category)
      : Promise.resolve();

    const page =
      category !== from.params.category
        ? 1
        : store.getters.content.currentPage++;

    await Promise.all([
      loadCategory,
      store.dispatch('content/getPage', { page, category }),
    ]);
    next();
  }

  async beforeRouteUpdate(to: Route, from: Route, next: Function) {
    const category: string | null =
      to.params.category !== undefined ? to.params.category : null;

    const loadCategory = category
      ? store.dispatch('categories/getCategory', category)
      : Promise.resolve();

    const page =
      category !== from.params.category
        ? 1
        : this.$store.getters.content.currentPage++;

    await Promise.all([
      loadCategory,
      store.dispatch('content/getPage', { page, category }),
    ]);
    next();
  }
}
